module.exports = __webpack_public_path__ + "img/session_complete@3x.b1320a1e.png";